import React, { useEffect, useState } from "react";
import { duration } from "moment";
function Countdown({ callback = () => {
}, className = "", timeInSeconds, paused = false }) {
  let tickTock = timeInSeconds;
  let logInterval;
  const defaultDuration = duration(timeInSeconds, "seconds").format("mm:ss");
  const [currentTime, setCurrentTime] = useState(defaultDuration);
  const startCountdown = () => {
    logInterval = setInterval(() => {
      tickTock -= 1;
      const currentDuration = duration(tickTock, "seconds").format("mm:ss", { trim: false });
      if (tickTock < 0) {
        tickTock = timeInSeconds;
        setCurrentTime(defaultDuration);
        clearInterval(logInterval);
        callback();
      } else {
        setCurrentTime(currentDuration);
      }
    }, 1e3);
  };
  useEffect(() => {
    if (paused) {
      clearInterval(logInterval);
    } else {
      startCountdown();
    }
    return () => {
      clearInterval(logInterval);
    };
  }, [paused]);
  return /* @__PURE__ */ React.createElement("span", { className }, currentTime);
}
export default Countdown;
